import React from "react";
import { SelectFilter } from "@design-system";
import { usePaginatedUserQuery } from "../../../hooks";
import { User } from "../../../graphql/types";

export const UserSelectContainer = ({
  onApplyFilter,
  onClearFilter,
  defaultValue,
}: {
  onApplyFilter: (values: number[]) => void;
  onClearFilter: () => void;
  defaultValue?: number[] | null | undefined;
}) => {
  const { state, search, loadMore, loading } = usePaginatedUserQuery({
    includeLoggedInUserFirst: true,
  });
  return (
    <SelectFilter
      defaultValue={defaultValue}
      loading={loading}
      optionsLabel="users"
      options={state.users.map(({ id, displayName }: User) => ({ value: id, label: displayName }))}
      onSearch={search}
      onApplyFilter={onApplyFilter}
      onClearFilter={() => {
        search("");
        onClearFilter();
      }}
      onLoadMore={loadMore}
    />
  );
};
